import { useEffect, useRef } from "react";
import { Textarea } from "./ui/textarea";

const MAX_LENGTH = 550;

export const ItemDescriptionField = ({
  value = "",
  onValueChange,
  placeholder = "Concepto",
  required = false,
  className = "",
  "data-testid": testId,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(Math.max(el.scrollHeight, 38), 150)}px`;
  }, [value]);

  const handleChange = (e) => {
    // Se guarda en una sola línea para no romper el CFDI ni el PDF
    onValueChange(e.target.value.replace(/[\r\n]+/g, " ").slice(0, MAX_LENGTH));
  };

  return (
    <div>
      <Textarea
        ref={ref}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        maxLength={MAX_LENGTH}
        rows={1}
        data-testid={testId}
        className={`min-h-[38px] resize-none overflow-y-auto leading-snug py-2 text-sm ${className}`}
      />
      <div className="flex justify-end">
        <span className={`text-[10px] ${value.length >= MAX_LENGTH ? "text-red-500" : "text-muted-foreground"}`}>
          {value.length}/{MAX_LENGTH}
        </span>
      </div>
    </div>
  );
};
